module.exports = __webpack_public_path__ + "media/advantages/advantage-img-1-5e7b9f27.png";